import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/Global-Services/common.service';
import { AppTokenHandler, HTTPStatus } from 'src/app/Global-Services/app-token-handler';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css'],
  standalone: false,
})
export class LogoutComponent implements OnInit {
  constructor(private gservice: CommonService, private tokenHandler: AppTokenHandler,
    public _navigateRoute: Router,
  ) { }

  ngOnInit() {
      this.gservice.Logout().subscribe((data: any) => {
        sessionStorage.removeItem('userToken');
        this.tokenHandler.clearSessionToken();
        sessionStorage.removeItem('userDetails');
        this.tokenHandler.clearAllAzureCookie();
      });
  }
  Login() {
      this.gservice.Login();
  }
}
